export enum AnalystTurnMode {
  Answer = 0,
  Report = 1,
}
